import { Skeleton } from '@/shared/ui/atoms';

/**
 * Card de indicador em carregamento: mesma moldura do `KpiCard`, com blocos no lugar do
 * rótulo e do valor — a altura bate com a do card real, então trocar filtro ou aba não faz
 * a página saltar.
 */
export function KpiCardSkeleton() {
  return (
    <div className="flex flex-col gap-quark rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface p-xxs shadow-level1">
      <Skeleton className="h-mini w-[7.5rem]" />
      <Skeleton className="h-xs w-[9.5rem]" />
    </div>
  );
}
